<template>
  <v-row v-if="!editable">
    <v-col order-md="1" cols="12" md="6">
      <v-text-field
        name="start_date"
        :value="form.start_date | dateFormat"
        :label="`${$t('PLANNINGS.START_DATE')} *`"
        :error-messages="errors.start_date"
        prepend-inner-icon="mdi-calendar"
        readonly
      />
    </v-col>

    <v-col order-md="3" cols="12" md="6">
      <v-text-field
        v-if="readonly"
        name="end_date"
        :value="form.end_date | dateFormat"
        :label="`${$t('PLANNINGS.END_DATE')} *`"
        :error-messages="errors.end_date"
        prepend-inner-icon="mdi-calendar"
        readonly
      ></v-text-field>

      <v-menu
        v-else
        ref="menuEndDate"
        min-width="290px"
        transition="scale-transition"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            name="end_date"
            autocomplete="nope"
            prepend-inner-icon="mdi-calendar"
            :value="form.end_date | dateFormat"
            :label="`${$t('PLANNINGS.END_DATE')} *`"
            :readonly="readonly"
            :rules="getRulesByName('end_date')"
            :error-messages="errors.end_date"
            clearable
            v-bind="attrs"
            v-on="on"
            @click:clear="form.end_date = null"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.end_date"
          :min="form.start_date"
          :max="maxEndDate"
          first-day-of-week="1"
          @change="setEndDate"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col order-md="2" cols="12" md="6">
      <weekdays
        v-model="form.days"
        :color="form.days.length ? 'primary' : 'black'"
        :error-messages="errors.days"
        :rules="rules.days"
        :readonly="readonly"
        @input="updateValue('days', $event)"
      ></weekdays>
    </v-col>

    <v-col order-md="4" cols="12" md="6">
      <v-select
        v-model="form.reiteration"
        outlined
        name="reiteration"
        item-value="id"
        item-text="name"
        :items="reiterationsList"
        :label="$t('PLANNINGS.INTERVAL')"
        :error-messages="errors.reiteration"
        :readonly="readonly"
        @change="updateValue('reiteration', $event)"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';

import Weekdays from '@/modules/_global/_components/Weekdays';
import formEditable from '@/modules/_global/mixins/form-editable';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import {
  notEmpty,
  requiredSelectArray
} from '@/modules/_global/variables/rules';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'BlockDayMultiTasksForm',

  filters: {
    dateFormat
  },

  components: {
    Weekdays
  },

  mixins: [formEditable, i18nRefreshData],

  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      valid: false,
      timeFrom: false,
      timeTo: false,
      form: {
        start_date: null,
        end_date: null,
        reiteration: 0,
        days: []
      },
      rules: {
        start_date: [notEmpty],
        end_date: [notEmpty],
        days: requiredSelectArray
      }
    };
  },

  computed: {
    ...mapState('planning', ['reiterationsList']),

    maxEndDate() {
      return moment(this.form.start_date || undefined)
        .add(6, 'month')
        .add(-1, 'day')
        .format(moment.HTML5_FMT.DATE);
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('planning', ['getReiterationsList']),

    refreshData() {
      this.getReiterationsList();
    },

    setEndDate(date) {
      this.$refs.menuEndDate.save(date);
      this.updateValue('end_date', date);
    }
  }
};
</script>

<style scoped></style>
